
import InlineLoading from 'vux/src/components/inline-loading/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import infiniteScroll from 'vue-infinite-scroll'

export default {
components: {
Tab, TabItem,
InlineLoading,
},
directives:{
infiniteScroll
},
watch:{
'$route.params.board':function(board){
console.log('board change')
this.timeout = 0;
this.board = board;
this.posts=[];
this.before = null;
this.busy = false;
this.getPost();
},
'popular':function(popular){
console.log('popular change')
this.timeout = 0;
this.popular=popular;
this.posts=[];
this.before = null;
this.busy = false;
this.getPost();
}
},
mounted(){
this.board = this.$route.params.board;

},
data () {
return {
popular:true,
index: 0,
tabList:[{index:0, name:'熱門', popular:true,},
{index:1, name:'最新', popular:false}],

board:undefined,
msg: 'Hello World!',
posts:[],
articleLength:0,
loading:false,
before:null,
timeout:0,
busy:false
}
},
methods:{
colorful(g){
if(g==='F') return 'color:rgb(255,192,203);'
else if(g==='M') return 'color:rgb(30,144,255);'

else return
},
clickPost(id){
this.$router.push('/post/'+id)
},
getPost(){

if(this.busy) return;
this.busy = true;


if(this.articleLength<30 && this.before!==null ) return 
this.loading=true;

let api = this.CORS + 'https://www.dcard.tw/_api/';
if(this.board!=undefined) api = api + 'forums/' + this.board + '/';
let url = api + 'posts'

this.$http.get(url,{
params:{
popular:this.popular,
before:this.before
}
}).then((response)=>{
this.articleLength = response.data.length;
if(this.articleLength===30){
this.before = response.data[this.articleLength-1].id;
this.busy = false;
}
else this.busy=true;

this.posts = this.posts.concat(response.data) ;
this.loading=false
}).catch((err)=>{
console.log("error:");
console.log(err);
this.loading="error"
this.busy = true
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/ArticleList.vue